import { ConnectivityView as Connectivity } from '@bymason-private/controller-shared-widgets';
import { Button, GoBell } from '@bymason-private/legacy-pattern-components';
import { RouterButton } from '@bymason-private/route-provider';
import Layout from '../../common/layout';
import { routes } from '../../router';

export default function ConnectivityView({ iccid }: { iccid?: string }) {
  return (
    <Layout
      headerRightAdornment={
        <RouterButton
          buttonComponent={
            <Button
              sx={{
                '& .MuiButton-startIcon': {
                  marginRight: 0.5,
                  paddingLeft: 0.5,
                  '& *:nth-of-type(1)': {
                    fontSize: 16,
                  },
                },
              }}
              color='secondary'
              startIcon={<GoBell />}
            >
              View/create notification rules
            </Button>
          }
          route={routes.Notifications}
        />
      }
      headerText='Connectivity'
    >
      <Connectivity iccid={iccid} simConnectivityRoute={routes.ConnectivitySims} />
    </Layout>
  );
}
